/**
 * Musu Preloader v7.3
 * No per-char animation, static gradient on tagline.
 */

const initPreloader = () => {
    const preloader = document.getElementById('theme-preloader');
    if (!preloader) return;

    const counter = preloader.querySelector('.theme-preloader__counter');
    const counterWrapper = preloader.querySelector('.theme-preloader__counter-wrapper');
    const branding = preloader.querySelector('.theme-preloader__branding');
    const tagline = document.getElementById('preloader-tagline');
    const shutterTop = preloader.querySelector('.theme-preloader__shutter.context-top');
    const shutterBottom = preloader.querySelector('.theme-preloader__shutter.context-bottom');
    const grain = preloader.querySelector('.theme-preloader__grain');

    if (typeof gsap === 'undefined') {
        preloader.style.display = 'none';
        document.body.classList.remove('is-loading');
        return;
    }

    gsap.killTweensOf([counterWrapper, branding, shutterTop, shutterBottom, grain]);

    // Smooth counter 0-100
    let startTime = null;
    const counterDuration = 2000;

    function animateCounter(timestamp) {
        if (!startTime) startTime = timestamp;
        const elapsed = timestamp - startTime;
        const progress = Math.min(elapsed / counterDuration, 1);
        const eased = progress * progress * (3 - 2 * progress);
        if (counter) counter.textContent = Math.round(eased * 100);

        if (progress < 1) {
            requestAnimationFrame(animateCounter);
        } else {
            // Swap counter → logo
            gsap.to(counterWrapper, {
                opacity: 0,
                duration: 0.3,
                ease: "power2.out",
                onComplete: () => {
                    gsap.to(branding, {
                        opacity: 1,
                        duration: 0.4,
                        ease: "power2.out"
                    });
                }
            });
        }
    }
    requestAnimationFrame(animateCounter);

    // Split exit
    window.addEventListener('load', () => {
        // Add pause after logo appears (counter takes 2000ms, fade 300ms, logo fade in 400ms = ~2700ms)
        // Then add 800ms pause to mark the "stop" before exit
        const splitDelay = 5300;
        const elapsed = performance.now();
        const remaining = Math.max(splitDelay - elapsed, 200);

        setTimeout(() => {
            // Fade tagline
            gsap.to(tagline, {
                opacity: 0,
                duration: 0.4,
                ease: "power2.out"
            });

            // Top shutter + logo UP
            gsap.to(shutterTop, {
                yPercent: -100,
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });
            gsap.to(branding, {
                y: "-55vh",
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });

            // Bottom shutter DOWN
            gsap.to(shutterBottom, {
                yPercent: 100,
                duration: 1.2,
                ease: "power3.inOut",
                force3D: true
            });

            gsap.to(grain, {
                opacity: 0,
                duration: 0.6,
                delay: 0.2
            });

            gsap.delayedCall(1.3, () => {
                preloader.style.display = 'none';
                document.body.classList.remove('is-loading');
            });
        }, remaining);
    });

    // Safety
    setTimeout(() => {
        if (preloader.style.display !== 'none') {
            document.body.classList.remove('is-loading');
            preloader.style.display = 'none';
        }
    }, 8000);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPreloader);
} else {
    initPreloader();
}
